var s = {
    XAGUSD: "XAG/USD",
    XAUUSD: "XAU/USD",

    AUDCAD: "AUD/CAD",
    AUDCHF: "AUD/CHF",
    AUDJPY: "AUD/JPY",
    AUDNZD: "AUD/NZD",
    AUDUSD: "AUD/USD",
    
    CADCHF: "CAD/CHF",
    CADJPY: "CAD/JPY",
    
    CHFJPY: "CHF/JPY",
    
    EURAUD: "EUR/AUD",
    EURCAD: "EUR/CAD",
    EURCHF: "EUR/CHF",
    EURGBP: "EUR/GBP",
    EURJPY: "EUR/JPY",
    EURNOK: "EUR/NOK",
    EURNZD: "EUR/NZD",
    EURSGD: "EUR/SGD",
    EURUSD: "EUR/USD",
    
    GBPAUD: "GBP/AUD",
    GBPCAD: "GBP/CAD",
    GBPCHF: "GBP/CHF",
    GBPJPY: "GBP/JPY",
    GBPNZD: "GBP/NZD",
    GBPUSD: "GBP/USD",
    
    NZDCAD: "NZD/CAD",
    NZDCHF: "NZD/CHF",
    NZDJPY: "NZD/JPY",
    NZDUSD: "NZD/USD",
    
    USDCAD: "USD/CAD",
    USDCHF: "USD/CHF",
    USDCNH: "USD/CNH",
    USDJPY: "USD/JPY",
    USDNOK: "USD/NOK",
    USDRUB: "USD/RUB",
    USDSGD: "USD/SGD",

    USDHKD: "USD/HKD",
    USDMXN: "USD/MXN",
    
    WTI: "WTI",
    BRN: "BRN",

    BCHUSD: "BCH/USD*",
    BTCUSD: "BTC/USD",
    ETHUSD: "ETH/USD",
    LTCUSD: "LTC/USD*",
    XRPUSD: "XRP/USD"
}

var inst = {
    metals: { "Metals": ["XAGUSD", "XAUUSD"] },
    exotic: { "USD": ["USDHKD", "USDMXN"] },
    main: { 
        "AUD": ["AUDCAD", "AUDCHF", "AUDJPY", "AUDNZD", "AUDUSD"], 
        "CAD": ["CADCHF", "CADJPY"], "CHF": ["CHFJPY"], 
        "EUR": ["EURAUD", "EURCAD", "EURCHF", "EURGBP", "EURJPY", "EURNOK", "EURNZD", "EURSGD", "EURUSD"], 
        "GBP": ["GBPAUD", "GBPCAD", "GBPCHF", "GBPJPY", "GBPNZD", "GBPUSD"], 
        "NZD": ["NZDCAD", "NZDCHF", "NZDJPY", "NZDUSD"], 
        "USD": ["USDCAD", "USDCHF", "USDCNH", "USDJPY", "USDNOK", "USDRUB", "USDSGD"]
    },
    commodities: { "Commodities": ["WTI", "BRN"] },
    crypto: { "Crypto": ["BCHUSD*", "BTCUSD", "ETHUSD", "LTCUSD*", "XRPUSD"] }
}

var allDate = {
    XAGUSD: "Silver Spot vs US Dollar",
    XAUUSD: "Gold Spot vs US Dollar",

    AUDCAD: "Australian Dollar vs Canadian Dollar",
    AUDCHF: "Australian Dollar vs Swiss Franc",
    AUDJPY: "Australian Dollar vs Japanise Yen",
    AUDNZD: "Australian Dollar vs New Zealand Dollar",
    AUDUSD: "Australian Dollar vs US Dollar",
    CADCHF: "Canadian Dollar vs Swiss Franc",
    CADJPY: "Canadian Dollar vs Japanese Yen",
    CHFJPY: "Swiss Frank vs Japanese Yen",
    EURAUD: "Euro vs Australian Dollar",
    EURCAD: "Euro vs Canadian Dollar",
    EURCHF: "Euro vs Swiss Franc",
    EURGBP: "Euro vs Great Britain Pound",
    EURJPY: "Euro vs Japanese Yen",
    EURNOK: "Euro vs Norwegian Krone",
    EURNZD: "Euro vs New Zealand Dollar",
    EURSGD: "Euro vs Singapore Dollar",
    EURUSD: "Euro vs US Dollar",
    GBPAUD: "Great Britan Pound vs Australian Dollar",
    GBPCAD: "Great Britain Pound vs Canadian Dollar",
    GBPCHF: "Great Britain Pound vs Swiss Franc",
    GBPJPY: "Great Britain Pound vs Japanese Yen",
    GBPNZD: "Great Britan Pound vs New Zealand Dollar",
    GBPUSD: "Great Britain Pound vs US Dollar",
    NZDCAD: "New Zealand Dollar vs Canadian Dollar",
    NZDCHF: "New Zealand Dollar vs Swiss Franc",
    NZDJPY: "New Zealand Dollar vs Japanese Yen",
    NZDUSD: "New Zealand Dollar vs US Dollar",
    USDCAD: "US Dollar vs Canadian Dollar",
    USDCHF: "US Dollar vs Swiss Franc",
    USDCNH: "US Dollar vs Chinese Offshore Yuan",
    USDJPY: "US Dollar vs Japanese Yen",
    USDNOK: "US Dollar vs Norwegian Krone",
    USDRUB: "US Dollar vs Russian Rouble",
    USDSGD: "US Dollar vs Singapore Dollar",

    USDHKD: "US Dollar vs Hong- Kong Dollar",
    USDMXN: "US Dollar vs Mexican Pesos",

    WTI: "Crude oil (WTI) USOIL",
    BRN: "Crude oil (Brent) UKOIL",

    BCHUSD: "BitCoin Cash",
    BTCUSD: "BitCoin",
    ETHUSD: "Ethereum",
    LTCUSD: "LiteCoin",
    XRPUSD: "Ripple",
}

var instForSpec = {
    all: ["XAGUSD", "XAUUSD", "USDHKD", "USDMXN", "AUDCAD", "AUDCHF", "AUDJPY", "AUDNZD", "AUDUSD", "CADCHF", "CADJPY", "EURAUD", "EURCAD", "EURCHF", "EURGBP", "EURJPY", "EURNOK", "EURNZD", "EURSGD", "EURUSD", "GBPAUD", "GBPCAD", "GBPCHF", "GBPJPY", "GBPNZD", "GBPUSD", "NZDCAD", "NZDCHF", "NZDJPY", "NZDUSD", "USDCAD", "USDCHF", "USDCNH", "USDJPY", "USDNOK", "USDRUB", "USDSGD", "DAX30", "WTI", "BRN", "BCHUSD", "BTCUSD", "ETHUSD", "LTCUSD", "XRPUSD"],
    metals: ["XAGUSD", "XAUUSD"],
    exotic: ["USDHKD", "USDMXN"],
    main: ["AUDCAD", "AUDCHF", "AUDJPY", "AUDNZD", "AUDUSD", "CADCHF", "CADJPY", "CHFJPY", "EURAUD", "EURCAD", "EURCHF", "EURGBP", "EURJPY", "EURNOK", "EURNZD", "EURSGD", "EURUSD", "GBPAUD", "GBPCAD", "GBPCHF", "GBPJPY", "GBPNZD", "GBPUSD", "NZDCAD", "NZDCHF", "NZDJPY", "NZDUSD", "USDCAD", "USDCHF", "USDCNH", "USDJPY", "USDNOK", "USDRUB", "USDSGD"],
    commodities: ["WTI", "BRN"],
    crypto: ["BCHUSD", "BTCUSD", "ETHUSD", "LTCUSD", "XRPUSD"]
};

var pairsSymbol = {
    AUDJPY: "3",
    CADJPY: "3",
    CHFJPY: "3",
    EURJPY: "3",
    GBPJPY: "3",
    NZDJPY: "3",
    USDJPY: "3",
    XAGUSD: "3",

    XAUUSD: "2",

    WTI: "2",
    BRN: "2"
};


var minLotSymbols = {
    STX50: "1",

    WTI: "1",
    BRN: "1"
}

var maxLotSymbols = {
    DAX30: "250",

    WTI: "250",
    BRN: "250",

    BCHUSD: "10",
    BTCUSD: "10",
    ETHUSD: "10",
    LTCUSD: "10",
    XRPUSD: "10"
}

var step = {
    WTI: "1",
    BRN: "1"
}


var baseStep = {
    XAGUSD: "5000",
    XAUUSD: "100",

    WTI: "100",
    BRN: "100",

    BCHUSD: "10",
    BTCUSD: "1",
    ETHUSD: "25",
    LTCUSD: "200",
    XRPUSD: "25 000"
};

var timeOpen = {
    "XAUUSD": "1:00:00",

    "WTI": "01:00:00",
    "BRN": "03:00:00",

    "BCHUSD": "00:00:00",
    "BTCUSD": "00:00:00",
    "ETHUSD": "00:00:00",
    "LTCUSD": "00:00:00",
    "XRPUSD": "00:00:00",
};

var timeClose = {
    "BCHUSD": "23:59:59",
    "BTCUSD": "23:59:59",
    "ETHUSD": "23:59:59",
    "LTCUSD": "23:59:59",
    "XRPUSD": "23:59:59"
};

var timeBreak = {
    "XAUUSD": "00:00 - 01:00",

    "WTI": "23:55 - 01:00",
    "BRN": "23:55 - 03:00",

    "BCHUSD": "12:00 - 15:00",
    "BTCUSD": "12:00 - 15:00",
    "ETHUSD": "12:00 - 15:00",
    "LTCUSD": "12:00 - 15:00",
    "XRPUSD": "12:00 - 15:00",
};

var timeBreakDay = {
};
